import { KeyValuePair } from '../index';

export enum SelectionStrategy {
    Children,
    Tags,
    Calculated
}

export class SelectionStrategyList {
    static enum: KeyValuePair<SelectionStrategy, string>[] = [
        {key: SelectionStrategy.Children, value:'Children groups'},
        {key: SelectionStrategy.Tags, value:'Single tag'},
        {key: SelectionStrategy.Calculated, value:'Calculated identifier'}
    ];
}